import { inject, Pipe, PipeTransform } from '@angular/core';

import { Channel } from '@campaign-portal/namespace/entities/channels/specs';
import { exist, Id, UUID } from '@campaign-portal/namespace/common/id';
import { IdObject } from '@campaign-portal/namespace/common/idObject';
import { Currency } from '@campaign-portal/namespace/entities/currency/specs';
import { Partner } from '@campaign-portal/namespace/entities/partners/specs';
import { SubscriptionGroup } from '@campaign-portal/namespace/entities/subscription-groups/specs';
import { ContractCompany } from '@campaign-portal/namespace/entities/contract-companies/specs';
import { PaymentSystem } from '@campaign-portal/namespace/entities/payment-systems/specs';
import { Subscription } from '@campaign-portal/namespace/entities/subscriptions/specs';

import {
	ChannelsService,
	CurrencyService,
	VendorSubscriptionsService,
	PartnersService,
	ContractCompaniesService,
	PaymentSystemsService,
	SubscriptionGroupsService,
} from '../services';

function findEntity<T>(id: Id<exist> | IdObject<exist>, dataMap: Map<exist | UUID, T>): T | null {
	if (id === null) {
		return null;
	}
	if (typeof id === 'number') {
		return dataMap.get(id) ?? null;
	}
	if (typeof id === 'object' && !Array.isArray(id)) {
		return dataMap.get(id.id) ?? null;
	}
	return null;
}

@Pipe({
	name: 'channel',
	standalone: true,
})
export class ChannelPipe implements PipeTransform {
	private readonly service = inject(ChannelsService);

	transform(id: Id<exist> | IdObject<exist>): Channel | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'partner',
	standalone: true,
})
export class PartnerPipe implements PipeTransform {
	private readonly service = inject(PartnersService);

	transform(id: Id<exist> | IdObject<exist>): Partner | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'product',
	standalone: true,
})
export class ProductPipe implements PipeTransform {
	private readonly service = inject(VendorSubscriptionsService);

	transform(id: Id<exist> | IdObject<exist>): Subscription | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'cCompany',
	standalone: true,
})
export class ContractCompanyPipe implements PipeTransform {
	private readonly service = inject(ContractCompaniesService);

	transform(id: Id<exist> | IdObject<exist>): ContractCompany | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'alarisCurrency',
	standalone: true,
})
export class AlarisCurrencyPipe implements PipeTransform {
	private readonly service = inject(CurrencyService);

	transform(id: Id<exist> | IdObject<exist>): Currency | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'paySystem',
	standalone: true,
})
export class PaymentSystemPipe implements PipeTransform {
	private readonly service = inject(PaymentSystemsService);

	transform(id: Id<exist> | IdObject<exist>): PaymentSystem | null {
		return findEntity(id, this.service.map);
	}
}

@Pipe({
	name: 'subGroup',
	standalone: true,
})
export class SubscriptionGroupPipe implements PipeTransform {
	private readonly service = inject(SubscriptionGroupsService);

	transform(id?: Id<exist> | IdObject<exist>): SubscriptionGroup | null {
		return id === undefined ? null : findEntity(id, this.service.map);
	}
}
